/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-add': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 13.75a3.75 3.75 0 01-3.213-1.825l-1.068.625a5 5 0 008.562 0l-1.069-.625A3.75 3.75 0 0110 13.75zM18.75 2.5h-2.5V0H15v2.5h-2.5v1.25H15v2.5h1.25v-2.5h2.5V2.5zM7.187 6.875A1.563 1.563 0 108.75 8.438a1.55 1.55 0 00-1.563-1.563zm5.625 0a1.563 1.563 0 101.563 1.563 1.55 1.55 0 00-1.563-1.563zm4.444 1.25c.158.613.24 1.242.244 1.875A7.5 7.5 0 1110 2.5V1.25a8.75 8.75 0 108.544 6.875h-1.288z"/>'
  }
})
